import {
  equalOrBeBelowLimit,
  getSampleButtonText,
  isCustomerLogin,
  noSample,
  shouldDisabledSampleButton,
  updateAllSampleButtons,
  updateCartCounter,
  updateCheckoutButton,
  updateSampleButtonText,
} from '../components/product-samples/product-samples';
import StyledDropdowns from '../utils/styled-dropdowns';
import { updateLinkedProductUrls } from '../utils/linked-product-urls';

/**
 * Cart JS is built off rivet.js
 * These are custom one-way binders: http://rivetsjs.com/docs/guide/#binders-one-way
 * usage: <span rv-color="data.goes.here" rv-bgcolor="data.goes.here"></span>
 * Note: the rivets binders are used on the cart.liquid template and the cart-drawer.liquid component
 */
const setCustomRivetsBinders = () => {
  const rv = window.rivets || {};
  rv.binders.color = function (el, value) {
    el.style.color = value;
  };
  rv.binders.bgcolor = function (el, value) {
    el.style.backgroundColor = value;
  };
  rv.formatters.or = function (value, args) {
    return value || args;
  };
};

export const updateCartWarning = () => {
  const items = document.querySelectorAll('.cart-list-item__inner');
  const isCustomerLoggedIn = isCustomerLogin();
  const exceedLimit = !equalOrBeBelowLimit();
  items?.forEach((el) => {
    const isSample = el.getAttribute('sample') === 'true';
    if (isSample) {
      if (exceedLimit && isCustomerLoggedIn) {
        el.classList.add('warning');
      } else if (!isCustomerLoggedIn) {
        // the only scenario it will exceed is (product finder or not logged in) and previous order with samples
        // without login, it never exceeds the limit
        // but we need to warn the customer here to login before checkout
        el.classList.add('highlight');
      } else if (isCustomerLoggedIn) {
        // not exceeding and logged in
        el.classList.add('highlight');
      }
    } else {
      el.classList.remove('warning');
      el.classList.remove('highlight');
    }
  });
};

const CartTemplate = async () => {
  StyledDropdowns('delivery-option-dropdown');
  setCustomRivetsBinders();

  const els = {
    deliverOptions: '.delivery-option',
    orderNoteTrigger: '.cart-template__right-column__order-note-trigger',
    orderNoteTarget: '.cart-template__right-column__order-note-field',
    cartItem: '.cart-list-item__inner',
  };

  document.addEventListener('DOMContentLoaded', function () {
    const checkCartLoaded = () => {
      const cartpage = document.querySelector('.cart-drawer__content');
      // TODO: optimize event listener, this isn't working 
      setTimeout(async () => {
        if (!cartpage) {
          checkCartLoaded();
        } else {
          await loadCartScript();
        }
      }, 1000);
    };
    checkCartLoaded();
  });

  const loadCartScript = async () => {
    updateAllSampleButtons();

    const cart = document.querySelector('.cart-drawer__content');
    // TODO: optimize event listener, this isn't working 
    cart?.addEventListener('click', function () {
      setTimeout(() => {
        updateCartWarning();
        updateCartCounter();
        updateCheckoutButton();
        updatePDPSampleButtonText();
      }, 1000);
    });

    const cartpage = document.querySelectorAll('.cart-list-item');

    cartpage.forEach(el => {
      el.addEventListener('click', function () {
        setTimeout(() => {
          updateCartCounter();
          updateCheckoutButton();
          updatePDPSampleButtonText();
          updateAllSampleButtons();

          if ((equalOrBeBelowLimit() && isCustomerLogin()) || noSample()) {
            const warning = document.querySelectorAll('.cart-sample-warning');
            const extraWarning = document.querySelectorAll('.cart-sample-extra-warning');
            warning?.forEach((el) => el.classList?.remove('red'));
            extraWarning?.forEach((el) => el.classList?.add('hide'));
          }
          updateCartWarning();
          // updateDrawerCartSampleBorder();
        }, 1000);
      })
    })

    const updatePDPSampleButtonText = () => {
      const dataset = document.querySelector('[data-product-form]')?.dataset;
      if (!dataset) return;
      const isKit = ['true', true].includes(dataset.sampleKit);
      const text = getSampleButtonText(dataset.sampleVariantId, isKit, isKit ? dataset.sampleKitWeight : 1);

      updateSampleButtonText(text, shouldDisabledSampleButton(text));
    }

    const updateCartSample = async () => {
      const freeItems = window.CartJS.cart.items.map((item, index) => ({ ...item, line_number: index + 1 })).filter((item) => item.line_price === 0 && (item.properties || {})['_sample'] !== 'true');
      await Promise.allSettled(freeItems.map((item) => window.CartJS.updateItem(item.line_number, 1, { _sample: 'true' })))
      if (freeItems.length) {
        updateCartCounter();
        updateCheckoutButton();
        updatePDPSampleButtonText();
        updateAllSampleButtons();
        updateCartWarning();
        // updateDrawerCartSampleBorder();
      }
    }

    await updateCartSample();
    updateCartWarning();
    // updateDrawerCartSampleBorder();
    updateLinkedProductUrls();
  };

  $(document).on('cart.requestComplete', function (event, cart) {
    // console.log('cart updated', cart);
    updateCartCounter(cart);
    updateCartWarning();
  });

  $(els.deliverOptions).on('click', function () {
    $(els.deliverOptions).removeClass('selected');
    $(this).addClass('selected');
  });

  $(els.orderNoteTrigger).on('click', function () {
    $(els.orderNoteTarget).toggleClass('active');
  });
};
export default CartTemplate;
